module.exports = __webpack_public_path__ + "static/media/goblin_axeman_circle.fe83f216.svg";